import * as React from "react";
import { forwardRef } from "react";
const SvgSmallDropdownIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 13, height: 8, viewBox: "0 0 13 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0.000781012 1.37505L1.07578 0.300048L6.02578 5.25005L10.9758 0.300049L12.0508 1.37505L6.02578 7.40005L0.000781012 1.37505Z", fill: "#646464" }));
const ForwardRef = forwardRef(SvgSmallDropdownIcon);
export { ForwardRef as ReactComponent };
